export default __webpack_public_path__ + "static/media/loadingComicFanatic.579aa82e.gif";